import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import { toast } from "react-toastify";
import { UpdateProductBody } from "api/api/productsApi/types";

export const updateProduct = createAsyncThunk<
  void,
  UpdateProductBody
>("products/updateProduct", async (body, { rejectWithValue }) => {
  try {
    const data = await productsApi.updateProduct(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const errData = error.response?.data as { title?: string };
      toast.error(errData ? errData?.title : "Что-то пошло не так... Попробуйте обновить страницу");
      return rejectWithValue(errData?.title || "Unknown error");
    } else {
      console.error("Error while updating products", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});